import { QRCodeSVG } from 'qrcode.react'

import type { CheckoutState } from '@/frontend/features/orders/hooks/use-handle-checkout'

interface DeclinedPaymentPanelProps {
  checkout: CheckoutState
}

/**
 * Renders the card-declined recovery UI — QR code for customer self-checkout
 * and a retry button for trying a different card. Returns null when there's
 * no declined invoice.
 */
export function DeclinedPaymentPanel({ checkout }: DeclinedPaymentPanelProps) {
  const { checkoutError } = checkout

  if (checkoutError?.kind !== 'payment-declined') return null

  return (
    <div className="mt-4 flex flex-col items-center gap-3 rounded-lg border border-destructive-border bg-destructive p-4">
      <p className="font-medium text-destructive-fg">Card declined</p>
      <p className="text-center text-muted-foreground">
        The customer can scan to pay on their phone, or select a different card and retry.
      </p>
      {checkoutError.hostedInvoiceUrl && (
        <QRCodeSVG value={checkoutError.hostedInvoiceUrl} size={160} />
      )}
      <a
        href={checkoutError.invoiceUrl}
        target="_blank"
        rel="noreferrer"
        className="text-sm text-muted-foreground underline underline-offset-3"
      >
        View invoice on Stripe
      </a>
    </div>
  )
}
